const yellow = '#b58900'

export default {
  hljs: {
    display: 'block',
    color: '#657b83',
    padding: '12px 10px 12px 18px',
    margin: 0,
  },

  'hljs-comment': {
    color: '#93a1a1',
  },
  'hljs-quote': {
    color: '#93a1a1',
  },

  'hljs-keyword': {
    color: '#cb4b16'
  },
  'hljs-subst': {
    color: '#cb4b16'
  },
  'hljs-link': {
    color: '#cb4b16'
  },
  'hljs-symbol': {
    color: '#cb4b16'
  },
  'hljs-bullet': {
    color: '#cb4b16'
  },
  'hljs-meta': {
    color: '#cb4b16',
    fontWeight: 'bold'
  },


  'hljs-selector-tag': {
    color: '#859900'
  },
  'hljs-addition': {
    background: '#859900'
  },

  'hljs-attr': {
    color: yellow
  },
  'hljs-attribute': {
    color: yellow
  },
  'hljs-variable': {
    color: yellow
  },
  'hljs-template-variable': {
    color: yellow
  },
  'hljs-class': {
    color: yellow
  },
  'hljs-title': {
    color: yellow,
    fontWeight: 'bold'
  },
  'hljs-type': {
    color: yellow
  },


  'hljs-literal': {
    color: '#2aa198'
  },
  'hljs-number': {
    color: '#2aa198'
  },
  'hljs-string': {
    color: '#2aa198'
  },
  'hljs-doctag': {
    color: '#2aa198'
  },
  'hljs-regexp': {
    color: '#2aa198'
  },

  'hljs-selector-id': {
    color: '#c1c9cf'
  },
  'hljs-selector-class': {
    color: '#c1c9cf'
  },
  'hljs-section': {
    color: '#c1c9cf'
  },
  'hljs-name': {
    color: '#c1c9cf',
    fontWeight: 'normal'
  },


  'hljs-built_in': {
    color: '#dc322f'
  },
  'hljs-builtin-name': {
    color: '#dc322f'
  },
  'hljs-deletion': {
    background: '#dc322f'
  },

  'hljs-params': {
    color: '#00f'
  },
  'hljs-tag': {
    color: '#000080',
    fontWeight: 'normal'
  },

  'hljs-emphasis': {
    fontStyle: 'italic'
  },
  'hljs-strong': {
    fontWeight: 'bold'
  }
}
